/* eslint-disable no-undef */
import { useEffect, Fragment, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import * as settingActions from "../../actions/settingActions";
import * as userAction from "../../actions/userActions";
import * as baseActions from "../../actions/baseActions";
import placeholder from "../../assets/images/userprofile.png";
import dash_menu7 from "../../assets/images/dash_menu7.png";
import pencil_icon from "../../assets/images/pencil_icon.png"
import { imgPath } from "../../utils/imagePath";
import LogoutModal from "../../utils/LogoutModal";
import PropTypes from "prop-types";
import { fetchRegPendingMentorRequests } from "../../Pages/PendingMenterRequest/Slice/pendingMenterRequestSlice";
import { loadRegPendingRequestData } from "../../Pages/MenteesRequest/Slice/menteesRequestSlice";
import { getSubdomainPath, handleConfirmLogout } from "../../utils/helpers";
import { getDatabase, onValue, ref } from "firebase/database";

function SidebarRemoveClass() {
  document.getElementById("OnscrollBody").classList.remove("show_sidebar");
  document.getElementById("OnscrollBody").classList.remove("chatbodyclass");
}

const SidebarLoader = () => (
  <div style={{ padding: "20px", textAlign: "center" }}>
    Loading...
  </div>
);

const Index = (props) => {

  const { title, actions, updateProfileData, setting, userInfo, pendingMenterRequest, menteesRequest } = props;
  const savedRole = localStorage.getItem("userRole");
  const dispatch = useDispatch();
  const subDomainPath = getSubdomainPath();
  const location = useLocation();
  // Mentor Requests
  const mentorPagination = pendingMenterRequest?.pagination ?? {};
  // Mentee Requests
  const menteePagination = menteesRequest?.pagination ?? {};
  // Totals
  const mentorTotal = mentorPagination?.total || 0;
  const menteeTotal = menteePagination?.total || 0;
  //Resolve role from redux OR localStorage
  const resolvedRole = userInfo?.role_id || savedRole || null;
  // Normalize role naming
  const roleId = resolvedRole === "Mentees" ? "Mentee" : resolvedRole;
  const [showModal, setShowModal] = useState(false);
  const moduleRenderData = setting?.module_data;
  const [unreadCount, setUnreadCount] = useState(0);

  const isSectionShow = (name) => {
    if (!Array.isArray(moduleRenderData)) return false;

    return moduleRenderData.some(
      (item) =>
        item?.name === name &&
        item?.status === "Enabled" &&
        item?.is_default === "Yes"
    );
  };

  const isDataReady =
    Array.isArray(setting?.module_data) &&
    setting.module_data.length > 0 &&
    userInfo?.id &&
    updateProfileData?.role_id;

  useEffect(() => {
    if (title) {
      document.title = title;
    }
    actions.getUserProfile(userInfo?.id);
  }, [title, actions, userInfo?.id]);

  useEffect(() => {
    actions.getSettingData();
  }, [actions]);

  useEffect(() => {
    if (!userInfo?.id) {
      return;
    }
    if (resolvedRole === "Mentees") {
      dispatch(
        // fetchPendingMentorRequests({
        //   request: {},
        //   userId: userInfo.id,
        // })
        fetchRegPendingMentorRequests({
          request: {},
          userId: userInfo.id,
        })
      );
    }

    dispatch(
      // loadPendingRequestData({
      //   status: 1,
      //   request: {},
      // })
      loadRegPendingRequestData({
        status: 1,
        request: {},
      })
    );

  }, [userInfo?.id, dispatch]);

  useEffect(() => {
    if (!userInfo?.id) return;

    const db = getDatabase();

    const userChatRef = ref(
      db,
      `users/${userInfo.id}`
    );

    const unsubscribe = onValue(
      userChatRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();

          let totalUnread = 0;

          Object.entries(data).forEach(
            ([roomKey, roomData]) => {

              // ignore currently opened room
              if (
                roomData?.current_open_room ===
                roomKey
              ) {
                return;
              }

              totalUnread +=
                roomData?.unread_count || 0;
            }
          );

          setUnreadCount(totalUnread);
        } else {
          setUnreadCount(0);
        }
      }
    );

    return () => unsubscribe();
  }, [userInfo?.id]);

  // Loader for userInfo (after all hooks)
  if (!userInfo?.id) {
    return <SidebarLoader />;
  }

  const handleLogOut = () => setShowModal(true);
  const profileImage = localStorage.getItem('profileImage')

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="dashboard_sidebar">
      <div className="dashboard_profile text-center mb-2 mb-md-3 mb-lg-4">
        <img src={updateProfileData.image || profileImage || placeholder} alt="dashboardImage" />
        <h5>
          {updateProfileData.first_name} {updateProfileData.last_name}
        </h5>
      </div>
      {isDataReady ? (
        <div className="dashboard_menu">
          <ul>
            {isSectionShow('My Profile') && (
              <li>
                {/* <NavLink to="/manage-profile" activeClassName="active" onClick={SidebarRemoveClass}> */}
                <NavLink to="/manage-profile" className={ location.pathname.startsWith("/manage-profile") ? "active" : "" } onClick={SidebarRemoveClass}>
                  <span>
                    <img
                      src={
                        imgPath + "dash_menu2.png"
                      }
                      alt="Manage My Profile"
                    />
                  </span>{' '}
                  Manage My Profile
                </NavLink>
              </li>
            )}
            {updateProfileData.role_id === "Mentees" && (
              <Fragment>
                <li className="active">
                  <NavLink to="/suggested-mentors" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span>
                      <img
                        src={
                          imgPath + "dash_menu1.png"
                        }
                        alt="Suggested Mentors"
                      />
                    </span>{' '}
                    Suggested Mentors
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/my-mentors" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span>
                      <img
                        src={
                          imgPath + "mentor_log_icon.png"
                        }
                        alt="View My Mentor"
                      />
                    </span>{' '}
                    View My Mentor
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/my-waitlist" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span>
                      <img
                        src={
                          imgPath + "mentor_log_icon.png"
                        }
                        alt="My Waitlist"
                      />
                    </span>{' '}
                    My Waitlist
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/pending-mentors" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span>
                      <img
                        src={
                          imgPath + "mentor_log_icon.png"
                        }
                        alt="Pending Mentor Requests"
                      />
                    </span>{' '}
                    Pending Mentor Requests
                    {mentorTotal > 0 && (
                      <span className="badge bg-danger ms-2">
                        {mentorTotal}
                      </span>
                    )}
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/my-diagnostic-toolkit" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span>
                      <img
                        src={
                          pencil_icon
                        }
                        alt="Self Assessment Tool"
                      />
                    </span>{' '}
                    {(subDomainPath === "siddev" || subDomainPath === "siduat" || subDomainPath === "sid") ? "Self Assessment Tool" : "Goal Setting"}
                  </NavLink>
                </li>

              </Fragment>
            )}
            {isSectionShow('Mentoring Engagement') && (
              <>
                <li>
                  <NavLink to="/certificate" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span style={{ width: 27 }}>
                      <img
                        src={
                          dash_menu7
                        }
                        alt="Certificate"
                      />
                    </span>{' '}
                    Certificate
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/schedule-meeting-calendar" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span style={{ width: 27 }}>
                      <img
                        src={
                          imgPath + "dash_menu3.png"
                        }
                        alt="ScheduleMeeting"
                      />
                    </span>{' '}
                    Calendar/Meetings
                  </NavLink>
                </li>
                {updateProfileData.role_id === "Mentor" && (
                  <Fragment>
                    <li className="active">
                      <NavLink to="/current-mentees" activeClassName="active" onClick={SidebarRemoveClass}>
                        <span>
                          <img
                            src={
                              imgPath + "dash_menu1.png"
                            }
                            alt="Current Mentees"
                          />
                        </span>{' '}
                        Current Mentees
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/mentees-request" activeClassName="active" onClick={SidebarRemoveClass}>
                        <span>
                          <img
                            src={
                              imgPath + "dash_menu2.png"
                            }
                            alt="Pending Requests"
                          />
                        </span>{' '}
                        Pending Requests
                        {menteeTotal > 0 && (
                          <span className="badge bg-danger ms-2">
                            {menteeTotal}
                          </span>
                        )}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/mentees-logs" activeClassName="active" onClick={SidebarRemoveClass}>
                        <span>
                          <img
                            src={
                              imgPath + "dash_menu2.png"
                            }
                            alt=" Past Mentees"
                          />
                        </span>{' '}
                        Past Mentees
                      </NavLink>
                    </li>
                  </Fragment>
                )}
              </>
            )}
            {isSectionShow('Mentoring Engagement') && (
              <>
                <li>
                  <NavLink to="/chat" activeClassName="active" onClick={SidebarRemoveClass}>
                    <span>
                      <img
                        src={
                          imgPath + "messages_icon.png"
                        }
                        alt="Messages"
                      />
                    </span>{' '}
                    Messages
                    {unreadCount > 0 && (
                      <span className="badge bg-danger ms-2">
                        {unreadCount}
                      </span>
                    )}
                  </NavLink>
                </li>
                {roleId && (
                  <li>
                    <NavLink
                      to="/refer"
                      activeClassName="active"
                      onClick={SidebarRemoveClass}
                    >
                      <span>
                        <img
                          src={imgPath + "refer_icon.png"}
                          alt={"Invite a " + roleId}
                        />
                      </span>
                      Invite a {roleId}
                    </NavLink>
                  </li>
                )}
              </>
            )}
            {isSectionShow('My Profile') && (
              <li>
                <NavLink to="/delete-my-profile" activeClassName="active" onClick={SidebarRemoveClass}>
                  <span>
                    <img
                      src={
                        imgPath + "delete_profile_icon.png"
                      }
                      alt="Delete My Profile"
                    />
                  </span>{' '}
                  Delete My Profile
                </NavLink>
              </li>
            )}
            <li>
              <Link to="/" onClick={(e) => { e?.preventDefault(); handleLogOut(); }}>
                <span>
                  <img
                    src={
                      imgPath + "dash_menu6.png"
                    }
                    alt="logout"
                  />
                </span>{' '}
                Logout
              </Link>
            </li>
          </ul>
          <LogoutModal
            show={showModal}
            onClose={handleCloseModal}
            onConfirm={() => handleConfirmLogout(actions, setShowModal, setting?.is_sso_enable == 1)}
            logoPath={setting?.logo_path}
          />
        </div>
      ) : (
        <SidebarLoader />
      )}
    </div >
  );
};

Index.propTypes = {
  title: PropTypes.string,

  actions: PropTypes.shape({
    getUserProfile: PropTypes.func.isRequired,
    getSettingData: PropTypes.func.isRequired,
    userLogout: PropTypes.func.isRequired,
  }).isRequired,

  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    role_id: PropTypes.string.isRequired,
  }).isRequired,

  updateProfileData: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    image: PropTypes.string,
    role_id: PropTypes.string,
  }).isRequired,

  setting: PropTypes.shape({
    logo_path: PropTypes.string,
    module_data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        status: PropTypes.string,
        is_default: PropTypes.string,
      })
    ),
  }).isRequired,
  menteesRequest: PropTypes.shape({
    pagination: PropTypes.shape({
      total: PropTypes.number,
    }),
  }),
  pendingMenterRequest: PropTypes.shape({
    pagination: PropTypes.shape({
      total: PropTypes.number,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    setting: state.setting,
    userInfo: state.userInfo,
    updateProfileData: state.updateProfileData,
    pendingMenterRequest: state.pendingMenterRequest,
    menteesRequest: state.menteesRequest,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...userAction,
        ...settingActions,
        ...baseActions,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
